import seoPages from '../data/seoPages.json';
import seoCategories from '../data/seoCategories.json';

export function loadSeoPage(slug) {
  return seoPages.find(page => page.slug === slug) || null;
}

export function getAllSeoPages() {
  return seoPages;
}

export function getPagesByCategory(categorySlug) {
  return seoPages.filter(page => page.category === categorySlug);
}

export function getRelatedPages(currentSlug, limit = 3) {
  const currentPage = seoPages.find(p => p.slug === currentSlug);
  if (!currentPage) return [];
  
  return seoPages
    .filter(page => page.slug !== currentSlug && currentPage.relatedSlugs?.includes(page.slug))
    .slice(0, limit);
}

export function getCategoryBySlug(slug) {
  return seoCategories.find(cat => cat.slug === slug) || null;
}

export function getAllCategories() {
  return seoCategories;
}

export function getCategoryPages(categorySlug) {
  return seoPages.filter(page => page.category === categorySlug);
}
